module.exports = "/work-site/img/banner-2.f04785b9.png";